module.exports = __webpack_public_path__ + "img/icon_palette.2b5327f9.png";